export const CONVENZIONI_DATA = {
  "auto-mobilita": {
    titolo: "Auto, Mobilità e Trasporti", icon: "Car",
    heroImage: "https://images.pexels.com/photos/164634/pexels-photo-164634.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80",
    partner: [
      { nome: "FCA | Fiat Chrysler Automobiles", slug: "fca-fiat-chrysler-automobiles" },
      { nome: "NTM Nuovo Trasporto Merci - Spedizione, Trasporti e Logistica", slug: "ntm-nuovo-trasporto-merci-spedizione-trasporti-e-logistica" },
      { nome: "Peugeot", slug: "peugeot" },
      { nome: "SABA PARCHEGGI | Parcheggio Roma Villa Borghese", slug: "saba-parcheggi-parcheggio-di-villa-borghese" },
    ],
  },
  "banche-assicurazioni": {
    titolo: "Banche e Assicurazioni", icon: "Landmark",
    partner: [
      { nome: "BCC - Conto Corrente e Linee di Credito in Convenzione", slug: "bcc-conto-corrente-e-linee-di-credito-in-convenzione" },
      { nome: "Generali Italia | Assicurazioni", slug: "generali-italia-assicurazioni" },
      { nome: "UNICREDIT | Offerta dedicata Confcommercio Roma", slug: "unicredit-offerta-dedicata-confcommercio-roma" },
      { nome: "Vittoria Assicurazioni", slug: "vittoria-assicurazioni" },
    ],
  },
  "energy-utilities": {
    titolo: "Energy e Utilities", icon: "Zap",
    partner: [
      { nome: "Dolomiti Energia", slug: "dolomiti-energia" },
      { nome: "Enel X Way", slug: "enel-x-way" },
      { nome: "Unoenergy", slug: "unoenergy" },
    ],
  },
  "famiglia-cultura-tempo-libero": {
    titolo: "Famiglia, Cultura e Tempo Libero", icon: "Heart",
    partner: [
      { nome: "Bambuc, l'arte che incontra la fantasia", slug: "bambuc-larte-che-incontra-la-fantasia" },
      { nome: "BRITISH SCHOOL | International", slug: "british-school-roma-centro" },
      { nome: "MARILAB | Analisi mediche", slug: "marilab-analisi-mediche" },
    ],
  },
  "prodotti-fornitura": {
    titolo: "Prodotti e Fornitura per l'impresa", icon: "Package",
    partner: [
      { nome: "AIMA | Gadget personalizzati", slug: "aima-laboratorio-creativo" },
      { nome: "GAP | Gestione Archivi", slug: "gapgestione-archivi" },
      { nome: "GROSSI PROGET | Food equipment - ZANUSSI PROFESSIONAL", slug: "grossi-proget-food-equipment-zanussi-professional" },
      { nome: "NTM Nuovo Trasporto Merci", slug: "ntm-nuovo-trasporto-merci-spedizione-trasporti-e-logistica" },
      { nome: "OKEL | Soluzioni tecnologiche", slug: "okel-soluzioni-tecnologiche" },
      { nome: "SCF | Musica d'ambiente e diritti connessi", slug: "scf-musica-dambiente-e-diritti-connessi" },
      { nome: "SIAE | Musica d'ambiente e diritti d'autore", slug: "siae-musica-dambiente-e-diritti-dautore" },
      { nome: "Stamperia Romana", slug: "stamperia-romana" },
      { nome: "VINCAL | Dispositivi di protezione individuale", slug: "vincal-dispositivi-di-protezione-individuale" },
      { nome: "Vodafone per il tuo business", slug: "vodafone-per-il-tuo-business" },
    ],
  },
  "servizi-impresa": {
    titolo: "Servizi per l'Impresa (comunicazione, marketing, IT)", icon: "Monitor",
    partner: [
      { nome: "CSO - Leader nel disbrigo pratiche", slug: "cso-leader-nel-disbrigo-pratiche" },
      { nome: "Customer Alliance | Consulenza digitale e Web reputation", slug: "customer-allianceconsulenza-digitale-e-web-reputation" },
      { nome: "Servizi Digitali INFOCERT TINEXTA GROUP", slug: "servizi-digitaliinfocert" },
      { nome: "SIRO CONSULTING", slug: "siro-consulting" },
      { nome: "Yocabe | La piattaforma intelligente per la crescita del tuo brand", slug: "yocabela-piattaforma-intelligente" },
    ],
  },
  "welfare-dipendenti": {
    titolo: "Welfare e Soluzioni per i dipendenti", icon: "UserCheck",
    partner: [
      { nome: "Double You | Portale e Servizi di Welfare Aziendale", slug: "double-you-portale-e-servizi-di-welfare-aziendale" },
      { nome: "Welfare aziendale | EDENRED", slug: "welfare-aziendale-edenred" },
    ],
  },
};
